exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "photo-input form{position:relative;display:inline-block}photo-input form .error{position:absolute;padding:0 9px;bottom:3px;font-size:12px;color:red}photo-input .md-input-invalid label,photo-input .ng-invalid{border-color:#dd2c00!important}photo-input .ng-invalid{border-width:0 0 2px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/common/photo-input/photo-input.scss
// module id = 729
// module chunks = 0